module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS8.74009416.jpg";